export const ERROR_CODES = {
  RELATED_CATEGORIES: "RELATED_CATEGORIES_ERROR",
  SERVICES_FOR_CATEGORY: "SERVICES_FOR_CATEGORY_ERROR",
  PRISMA_GET_INTEGRATION: "PRISMA_GET_INTEGRATION_ERROR",
  GET_AUTH_AND_WEBSITE: "GET_AUTH_AND_WEBSITE_ERROR",
  PRISMA_GET_WEBSITE_ERROR: "PRISMA_GET_WEBSITE_ERROR",
  GSC_WEBSITE_NOT_FOUND: "GSC_WEBSITE_NOT_FOUND_ERROR",
  GSC_INTEGRATION_NOT_FOUND: "GSC_INTEGRATION_NOT_FOUND_ERROR",
  GSC_ANALYTICS_INTEGRATION_EXISTS: "GSC_ANALYTICS_INTEGRATION_EXISTS_ERROR",
  GSC_QUERY_FAILED: "GSC_QUERY_FAILED_ERROR",
  GSC_NO_DATA_FOR_DATE: "GSC_NO_DATA_FOR_DATE_ERROR",
  PRISMA_UPDATE_INTEGRATION_ERROR: "PRISMA_UPDATE_INTEGRATION_ERROR",
  SITE_VERIFICATION_NOT_OWNER_ERROR: "SITE_VERIFICATION_NOT_OWNER_ERROR",
  GSC_DOMAIN_MISCONFIGURED: "GSC_DOMAIN_MISCONFIGURED_ERROR",
  GSC_GET_SITEMAPS_ERROR: "GSC_GET_SITEMAPS_ERROR",
  INDEX_NOW_SUBMISSION_ERROR: "INDEX_NOW_SUBMISSION_ERROR",
  POLL_GSC_INTEGRATION_INVALID_REQUEST: "POLL_GSC_INTEGRATION_INVALID_REQUEST_ERROR",
  SITE_VERIFICATION_INSERT_TOKEN_ERROR: "SITE_VERIFICATION_INSERT_TOKEN_ERROR",
  SITE_VERIFICATION_TOKEN_NOT_FOUND_ERROR: "SITE_VERIFICATION_TOKEN_NOT_FOUND_ERROR",
  SITE_VERIFICATION_GET_VERIFICATION_STATUS_ERROR: "SITE_VERIFICATION_GET_VERIFICATION_STATUS_ERROR",
  GSC_SUBMIT_SITEMAP_ERROR: "GSC_SUBMIT_SITEMAP_ERROR",
  UPDATE_INTEGRATION_METADATA_ERROR: "UPDATE_INTEGRATION_METADATA_ERROR",
  GSC_ADD_DOMAIN_ERROR: "GSC_ADD_DOMAIN_ERROR",
  GSC_METRICS_ERROR: "GSC_METRICS_ERROR",
  UMAMI_METRICS_ERROR: "UMAMI_METRICS_ERROR",
  UMAMI_INITIALIZATION_ERROR: "UMAMI_INITIALIZATION_ERROR",
  PRISMA_UPDATE: "PRISMA_UPDATE_ERROR",
  CLERK_GET_CLIENT_ERROR: "CLERK_GET_CLIENT_ERROR",
  CLERK_GET_ORGANIZATION_ERROR: "CLERK_GET_ORGANIZATION_ERROR",
  CLERK_ORGANIZATION_NOT_FOUND_ERROR: "CLERK_ORGANIZATION_NOT_FOUND_ERROR",
  CLERK_WEBHOOK_PROCESSING_ERROR: "CLERK_WEBHOOK_PROCESSING_ERROR",
  EMPTY_CLERK_CLIENT_DATA_ERROR: "EMPTY_CLERK_CLIENT_DATA_ERROR",
  SEND_EMAIL_ERROR: "SEND_EMAIL_ERROR",
  PRISMA_UPDATE_WEBSITE_ERROR: "PRISMA_UPDATE_WEBSITE_ERROR",
  NOT_FOUND: "NOT_FOUND_ERROR",
  PRISMA_FIND: "PRISMA_FIND_ERROR",
  DEFAULT_GROUP_DELETE: "DEFAULT_GROUP_DELETE_ERROR",
  PARSE_GROUP_INFO: "PARSE_GROUP_INFO_ERROR",
  EXTRACTING_INFO_FROM_MEDIA_URL_ERROR: "EXTRACTING_INFO_FROM_MEDIA_URL_ERROR",
  SENDING_TEXT_MESSAGE_ERROR: "SENDING_TEXT_MESSAGE_ERROR",
  GEORESTRICTED_PHONE_NUMBER_ERROR: "GEORESTRICTED_PHONE_NUMBER_ERROR",
  OPTED_OUT_PHONE_NUMBER_ERROR: "OPTED_OUT_PHONE_NUMBER_ERROR",
  UPLOADING_MEDIA_TO_IMAGEKIT_ERROR: "UPLOADING_MEDIA_TO_IMAGEKIT_ERROR",
  ORGANIZATION_NOT_FOUND: "ORGANIZATION_NOT_FOUND_ERROR",
  UNAUTHORIZED: "UNAUTHORIZED_ERROR",
  INVALID_CUSTOM_DOMAIN_ERROR: "INVALID_CUSTOM_DOMAIN_ERROR",
  INVALID_PAGESPEED_API_KEY: "INVALID_PAGESPEED_API_KEY_ERROR",
  ANALYTICS_INTEGRATION_NOT_FOUND: "ANALYTICS_INTEGRATION_NOT_FOUND_ERROR",
  GBP_INTEGRATION_INITIALIZATION_ERROR: "GBP_INTEGRATION_INITIALIZATION_ERROR",
  ANALYTICS_REPORT_INSUFFICIENT_DATA: "ANALYTICS_REPORT_INSUFFICIENT_DATA_ERROR",
  ANALYTICS_REPORT_NOT_AVAILABLE: "ANALYTICS_REPORT_NOT_AVAILABLE_ERROR",
  PAGESPEED_ANALYSIS_FAILED: "PAGESPEED_ANALYSIS_FAILED_ERROR",
  PAGESPEED_INTEGRATION_INITIALIZATION_ERROR: "PAGESPEED_INTEGRATION_INITIALIZATION_ERROR",
  INVALID_REQUEST: "INVALID_REQUEST_ERROR",
  CLERK_GET_ORGANIZATION_MEMBERS_ERROR: "CLERK_GET_ORGANIZATION_MEMBERS_ERROR",
  CLERK_INVITE_MEMBER_ERROR: "CLERK_INVITE_MEMBER_ERROR",
  CLERK_REMOVE_MEMBER_ERROR: "CLERK_REMOVE_MEMBER_ERROR",
  CLERK_UPDATE_MEMBER_ERROR: "CLERK_UPDATE_MEMBER_ERROR",
  CLERK_USER_NOT_FOUND: "CLERK_USER_NOT_FOUND_ERROR",
  INVALID_QUERY_PARAMETERS_ERROR: "INVALID_QUERY_PARAMETERS_ERROR",
  INVALID_BODY_PARAMETERS_ERROR: "INVALID_BODY_PARAMETERS_ERROR",
  GET_FORMATTED_PROMPT_ERROR: "GET_FORMATTED_PROMPT_ERROR",
  CLERK_GET_ORGANIZATION_INVITATIONS_ERROR: "CLERK_GET_ORGANIZATION_INVITATIONS_ERROR",
  CLERK_REVOKE_ORGANIZATION_INVITATION_ERROR: "CLERK_REVOKE_ORGANIZATION_INVITATION_ERROR",
  PROCESS_SECTION_ERROR: "PROCESS_SECTION_ERROR",
  PROMPT_NOT_DEFINED: "PROMPT_NOT_DEFINED",
  OPENAI_API_ERROR: "OPENAI_API_ERROR",

  // Quote related error codes
  QUOTE_DETAILS_INSUFFICIENT: "QUOTE_DETAILS_INSUFFICIENT_ERROR",

  // Subscription related error codes
  FEATURE_UNAVAILABLE_FOR_SUBSCRIPTION_ERROR: "FEATURE_UNAVAILABLE_FOR_SUBSCRIPTION_ERROR",

  // Deal-related error codes
  DEAL_CLOSER_NOT_FOUND: "DEAL_CLOSER_NOT_FOUND_ERROR",
  FUNNEL_NOT_FOUND: "FUNNEL_NOT_FOUND_ERROR",
  DEAL_NOT_FOUND: "DEAL_NOT_FOUND_ERROR",
  DEAL_CLOSER_NAME_EXISTS: "DEAL_CLOSER_NAME_EXISTS_ERROR",
  FUNNEL_NAME_EXISTS: "FUNNEL_NAME_EXISTS_ERROR",
  DEAL_CREATE_ERROR: "DEAL_CREATE_ERROR",
  DEAL_UPDATE_ERROR: "DEAL_UPDATE_ERROR",
  DEAL_CLOSER_CREATE_ERROR: "DEAL_CLOSER_CREATE_ERROR",
  DEAL_CLOSER_UPDATE_ERROR: "DEAL_CLOSER_UPDATE_ERROR",
  DEAL_CLOSER_DELETE_ERROR: "DEAL_CLOSER_DELETE_ERROR",
  FUNNEL_CREATE_ERROR: "FUNNEL_CREATE_ERROR",
  FUNNEL_UPDATE_ERROR: "FUNNEL_UPDATE_ERROR",
  FUNNEL_DELETE_ERROR: "FUNNEL_DELETE_ERROR",

  // Stripe/Payment Link related error codes
  STRIPE_SUBSCRIPTION_RETRIEVAL_ERROR: "STRIPE_SUBSCRIPTION_RETRIEVAL_ERROR",
  SUBSCRIPTION_PRICE_NOT_FOUND: "SUBSCRIPTION_PRICE_NOT_FOUND_ERROR",
  SUBSCRIPTION_PRICE_AMOUNT_NOT_FOUND: "SUBSCRIPTION_PRICE_AMOUNT_NOT_FOUND_ERROR",
  PAYMENT_LINK_NOT_FOUND: "PAYMENT_LINK_NOT_FOUND_ERROR",

  PUPPETEER_LAUNCH_ERROR: "PUPPETEER_LAUNCH_ERROR",

  // Blob storage related error codes
  BLOB_DELETE_ERROR: "BLOB_DELETE_ERROR",
  ANALYTICS_REPORT_DELETE_ERROR: "ANALYTICS_REPORT_DELETE_ERROR",

  // GBP related error codes
  GBP_INTEGRATION_NOT_FOUND: "GBP_INTEGRATION_NOT_FOUND_ERROR",
  GBP_INTEGRATION_CREATE_ERROR: "GBP_INTEGRATION_CREATE_ERROR",
  GBP_SCORE_CALCULATION_ERROR: "GBP_SCORE_CALCULATION_ERROR",
  GBP_SCORE_BUSINESS_INFO_FETCH_ERROR: "GBP_SCORE_BUSINESS_INFO_FETCH_ERROR",
  GBP_SCORE_REVIEWS_FETCH_ERROR: "GBP_SCORE_REVIEWS_FETCH_ERROR",
  GBP_SCORE_LOCATION_MEDIA_FETCH_ERROR: "GBP_SCORE_LOCATION_MEDIA_FETCH_ERROR",
  GBP_SCORE_DESCRIPTION_EVALUATION_ERROR: "GBP_SCORE_DESCRIPTION_EVALUATION_ERROR",
  GBP_SCORE_UPDATE_FIELDS_ERROR: "GBP_SCORE_UPDATE_FIELDS_ERROR",

  // Knock related error codes
  KNOCK_WORKFLOW_TRIGGER_ERROR: "KNOCK_WORKFLOW_TRIGGER_ERROR",

  // Section related error codes
  SECTION_MOVE_TO_POSITION_ERROR: "SECTION_MOVE_TO_POSITION_ERROR",
  SECTION_NOT_FOUND: "SECTION_NOT_FOUND_ERROR",
  SECTION_INVALID_MOVE: "SECTION_INVALID_MOVE_ERROR",

  // social automation related error codes
  NO_MEDIA_PROVIDED_FOR_INSTAGRAM_POST: "NO_MEDIA_PROVIDED_FOR_INSTAGRAM_POST_ERROR",

  // website builder related error codes
  TRANSCRIPT_ANALYSIS_INVALID_REQUEST: "TRANSCRIPT_ANALYSIS_INVALID_REQUEST_ERROR",
  TRANSCRIPT_ANALYSIS_OPENAI_ERROR: "TRANSCRIPT_ANALYSIS_OPENAI_ERROR",
  TRANSCRIPT_ANALYSIS_PARSE_ERROR: "TRANSCRIPT_ANALYSIS_PARSE_ERROR",
  SOCIAL_AUTOMATION_NOT_FOUND: "SOCIAL_AUTOMATION_NOT_FOUND_ERROR",
  SOCIAL_AUTOMATION_PAUSED_DUE_TO_INACTIVITY: "SOCIAL_AUTOMATION_PAUSED_DUE_TO_INACTIVITY_ERROR",
  SOCIAL_AUTOMATION_NOT_ACTIVE: "SOCIAL_AUTOMATION_NOT_ACTIVE_ERROR",
  SOCIAL_AUTOMATION_NO_PRIMARY_PHONE: "SOCIAL_AUTOMATION_NO_PRIMARY_PHONE_ERROR",
  SOCIAL_POST_FETCH_ERROR: "SOCIAL_POST_FETCH_ERROR",

  WEBSITE_NOT_ACTIVE: "WEBSITE_NOT_ACTIVE_ERROR",
  SVG_SANITIZATION_FAILED: "SVG_SANITIZATION_FAILED_ERROR",
  // serpapi related error codes
  SERPAPI_CONFIGURATION_ERROR: "SERPAPI_CONFIGURATION_ERROR",
  SERPAPI_VALIDATION_ERROR: "SERPAPI_VALIDATION_ERROR",
  SERPAPI_REQUEST_ERROR: "SERPAPI_REQUEST_ERROR",
  SERPAPI_INVALID_PLACE_ID: "SERPAPI_INVALID_PLACE_ID_ERROR",
  /** SerpAPI google_maps text search returned no local listings (distinct from an invalid place_id). */
  SERPAPI_GOOGLE_MAPS_NO_RESULTS: "SERPAPI_GOOGLE_MAPS_NO_RESULTS_ERROR",

  // Company name related error codes
  INVALID_COMPANY_NAME: "INVALID_COMPANY_NAME_ERROR",

  // Reviews related error codes
  INVALID_PLACE_ID: "INVALID_PLACE_ID_ERROR",

  // AI Content Validation related error codes
  AI_CONTENT_QUALITY_CHECK_FAILED: "AI_CONTENT_QUALITY_CHECK_FAILED_ERROR",
  AI_CONTENT_VALIDATION_SERVICE_ERROR: "AI_CONTENT_VALIDATION_SERVICE_ERROR",

  // external service related error codes
  EXTERNAL_SERVICE_ERROR: "EXTERNAL_SERVICE_ERROR",

  // call tracking related error codes
  CALL_TRACKING_NUMBER_NOT_FOUND: "CALL_TRACKING_NUMBER_NOT_FOUND_ERROR",
  CALL_TRACKING_NUMBER_CREATE_ERROR: "CALL_TRACKING_NUMBER_CREATE_ERROR",
  CALL_TRACKING_NUMBER_UPDATE_ERROR: "CALL_TRACKING_NUMBER_UPDATE_ERROR",
  CALL_TRACKING_NUMBER_DELETE_ERROR: "CALL_TRACKING_NUMBER_DELETE_ERROR",
  CALL_RECORD_NOT_FOUND: "CALL_RECORD_NOT_FOUND_ERROR",
  CALL_RECORD_CREATE_ERROR: "CALL_RECORD_CREATE_ERROR",
  CALL_RECORD_UPDATE_ERROR: "CALL_RECORD_UPDATE_ERROR",
  TELNYX_API_ERROR: "TELNYX_API_ERROR",

  // vapi recording artifact download error codes — distinguish why an
  // authenticated recording download failed so retries/alerts can react.
  VAPI_RECORDING_AUTH_ERROR: "VAPI_RECORDING_AUTH_ERROR",
  VAPI_RECORDING_NOT_FOUND: "VAPI_RECORDING_NOT_FOUND_ERROR",
  VAPI_RECORDING_REDIRECT_ERROR: "VAPI_RECORDING_REDIRECT_ERROR",
  VAPI_RECORDING_DOWNLOAD_ERROR: "VAPI_RECORDING_DOWNLOAD_ERROR",

  // customer hub related error codes
  CUSTOMER_RECORD_NOT_FOUND: "CUSTOMER_RECORD_NOT_FOUND_ERROR",
  CUSTOMER_RECORD_CREATE_ERROR: "CUSTOMER_RECORD_CREATE_ERROR",
  CUSTOMER_RECORD_UPDATE_ERROR: "CUSTOMER_RECORD_UPDATE_ERROR",
  CUSTOMER_RECORD_DELETE_ERROR: "CUSTOMER_RECORD_DELETE_ERROR",
  CUSTOMER_RECORD_LOOKUP_ERROR: "CUSTOMER_RECORD_LOOKUP_ERROR",
  CUSTOMER_RECORD_FIND_OR_CREATE_ERROR: "CUSTOMER_RECORD_FIND_OR_CREATE_ERROR",

  // telnyx related error codes
  TELNYX_WEBHOOK_PROCESSING_ERROR: "TELNYX_WEBHOOK_PROCESSING_ERROR",
  TRACKING_NUMBER_TYPE_NOT_ALLOWED: "TRACKING_NUMBER_TYPE_NOT_ALLOWED_ERROR",
  ORGANIC_TRACKING_NUMBER_LIMIT_REACHED: "ORGANIC_TRACKING_NUMBER_LIMIT_REACHED_ERROR",
  TRACKING_NUMBER_DESTINATION_ALREADY_EXISTS: "TRACKING_NUMBER_DESTINATION_ALREADY_EXISTS_ERROR",
  INVALID_PHONE_NUMBER: "INVALID_PHONE_NUMBER_ERROR",
  TELNYX_AUTH_ERROR: "TELNYX_AUTH_ERROR",
  TELNYX_NUMBER_SEARCH_ERROR: "TELNYX_NUMBER_SEARCH_ERROR",
  TELNYX_NUMBER_PROVISION_ERROR: "TELNYX_NUMBER_PROVISION_ERROR",
  TELNYX_NUMBER_DELETE_ERROR: "TELNYX_NUMBER_DELETE_ERROR",
  TELNYX_WEBHOOK_SIGNATURE_ERROR: "TELNYX_WEBHOOK_SIGNATURE_ERROR",
  TELNYX_TRANSCRIPTION_ERROR: "TELNYX_TRANSCRIPTION_ERROR",
  CALL_FORWARDING_CONFIG_ERROR: "CALL_FORWARDING_CONFIG_ERROR",
  INVALID_PHONE_NUMBER_ERROR: "INVALID_PHONE_NUMBER_ERROR",

  // onboarding ingestion related error codes
  TRANSCRIPT_EXTRACT_FORM_ANSWERS: "TRANSCRIPT_EXTRACT_FORM_ANSWERS_ERROR",
  FIREFLIES_TRANSCRIPT_GET_ERROR: "FIREFLIES_TRANSCRIPT_GET_ERROR",

  // conflict related error codes
  CONFLICT: "CONFLICT_ERROR",

  //versioning related error codes
  CREATE_WEBSITE_VERSION_ERROR: "CREATE_WEBSITE_VERSION_ERROR",
  GET_WEBSITE_VERSION_ERROR: "PRISMA_GET_WEBSITE_VERSION_ERROR",
  ROLLBACK_WEBSITE_TO_VERSION_ERROR: "ROLLBACK_WEBSITE_TO_VERSION_ERROR",

  // job related error codes
  JOB_CREATE_ERROR: "JOB_CREATE_ERROR",

  // review request related error codes
  REVIEW_REQUEST_CREATE_ERROR: "REVIEW_REQUEST_CREATE_ERROR",
  REVIEW_REQUEST_NOT_FOUND: "REVIEW_REQUEST_NOT_FOUND_ERROR",
  REVIEW_REQUEST_UPDATE_ERROR: "REVIEW_REQUEST_UPDATE_ERROR",
  REVIEW_REQUEST_ALREADY_COMPLETED: "REVIEW_REQUEST_ALREADY_COMPLETED_ERROR",
  REVIEW_REQUEST_INVALID_DATA: "REVIEW_REQUEST_INVALID_DATA_ERROR",

  // review related error codes
  REVIEW_CREATE_ERROR: "REVIEW_CREATE_ERROR",
  REVIEW_NOT_FOUND: "REVIEW_NOT_FOUND_ERROR",
  REVIEW_UPDATE_ERROR: "REVIEW_UPDATE_ERROR",
  REVIEW_REPLY_GENERATION_ERROR: "REVIEW_REPLY_GENERATION_ERROR",
  REVIEW_IMPORT_INTEGRATION_NOT_FOUND: "REVIEW_IMPORT_INTEGRATION_NOT_FOUND_ERROR",
  REVIEW_IMPORT_NO_OAUTH_TOKENS: "REVIEW_IMPORT_NO_OAUTH_TOKENS_ERROR",
  REVIEW_IMPORT_ERROR: "REVIEW_IMPORT_ERROR",

  // segment server related error codes
  SEGMENT_SERVER_TRACK_ERROR: "SEGMENT_SERVER_TRACK_ERROR",

  // google api related error codes
  GOOGLE_REVIEW_REPLY_FAILED: "GOOGLE_REVIEW_REPLY_FAILED_ERROR",
  GOOGLE_TOKEN_REFRESH_FAILED: "GOOGLE_TOKEN_REFRESH_FAILED_ERROR",
  GBP_PERMISSION_DENIED: "GBP_PERMISSION_DENIED_ERROR",
  GBP_LOCATION_UNCLAIMED: "GBP_LOCATION_UNCLAIMED_ERROR",

  // partnerstack related error codes
  PARTNERSTACK_CREATE_REFERRAL_LINK_ERROR: "PARTNERSTACK_CREATE_REFERRAL_LINK_ERROR",
  PARTNERSTACK_USER_ALREADY_MEMBER: "PARTNERSTACK_USER_ALREADY_MEMBER_ERROR",

  // smm/project post related error codes
  POST_IMAGE_DESCRIPTION_ERROR: "POST_IMAGE_DESCRIPTION_ERROR",
  POST_TEXT_GENERATION_ERROR: "POST_TEXT_GENERATION_ERROR",

  // rainforest related error codes
  RAINFOREST_MERCHANT_CREATE_ERROR: "RAINFOREST_MERCHANT_CREATE_ERROR",
  RAINFOREST_MERCHANT_NOT_FOUND: "RAINFOREST_MERCHANT_NOT_FOUND_ERROR",
  RAINFOREST_SESSION_CREATE_ERROR: "RAINFOREST_SESSION_CREATE_ERROR",
  RAINFOREST_API_ERROR: "RAINFOREST_API_ERROR",
  RAINFOREST_WEBHOOK_PROCESSING_ERROR: "RAINFOREST_WEBHOOK_PROCESSING_ERROR",
  RAINFOREST_PAYIN_CONFIG_ERROR: "RAINFOREST_PAYIN_CONFIG_ERROR",
  RAINFOREST_PAYMENT_SESSION_ERROR: "RAINFOREST_PAYMENT_SESSION_ERROR",

  // billing/payments related error codes
  QUOTE_DEPOSIT_NOT_PAID: "QUOTE_DEPOSIT_NOT_PAID_ERROR",
  INVOICE_NOT_PAYABLE: "INVOICE_NOT_PAYABLE_ERROR",
  PAYMENT_AMOUNT_INVALID: "PAYMENT_AMOUNT_INVALID_ERROR",

  // client portal related error codes
  CLIENT_PORTAL_TOKEN_INVALID: "CLIENT_PORTAL_TOKEN_INVALID_ERROR",
  CLIENT_PORTAL_TOKEN_EXPIRED: "CLIENT_PORTAL_TOKEN_EXPIRED_ERROR",
  CLIENT_PORTAL_CUSTOMER_NOT_FOUND: "CLIENT_PORTAL_CUSTOMER_NOT_FOUND_ERROR",
  CLIENT_PORTAL_TOKEN_GENERATION_ERROR: "CLIENT_PORTAL_TOKEN_GENERATION_ERROR",
  CLIENT_PORTAL_SERVICE_REQUEST_CREATE_ERROR: "CLIENT_PORTAL_SERVICE_REQUEST_CREATE_ERROR",
  CLIENT_PORTAL_REFERRAL_CREATE_ERROR: "CLIENT_PORTAL_REFERRAL_CREATE_ERROR",
  CLIENT_PORTAL_REVIEW_REQUEST_ERROR: "CLIENT_PORTAL_REVIEW_REQUEST_ERROR",
  // portal verification (confirm-on-file gate on sensitive actions)
  CLIENT_PORTAL_VERIFICATION_REQUIRED: "CLIENT_PORTAL_VERIFICATION_REQUIRED_ERROR",
  CLIENT_PORTAL_VERIFICATION_FAILED: "CLIENT_PORTAL_VERIFICATION_FAILED_ERROR",
  CLIENT_PORTAL_VERIFICATION_LOCKED: "CLIENT_PORTAL_VERIFICATION_LOCKED_ERROR",
  CLIENT_PORTAL_VERIFICATION_UNAVAILABLE: "CLIENT_PORTAL_VERIFICATION_UNAVAILABLE_ERROR",

  // ai voice assistant related error codes
  AI_VOICE_ASSISTANT_CREATE_ERROR: "AI_VOICE_ASSISTANT_CREATE_ERROR",
  AI_VOICE_ASSISTANT_UPDATE_ERROR: "AI_VOICE_ASSISTANT_UPDATE_ERROR",
  AI_VOICE_ASSISTANT_DELETE_ERROR: "AI_VOICE_ASSISTANT_DELETE_ERROR",
  AI_VOICE_ASSISTANT_NOT_FOUND: "AI_VOICE_ASSISTANT_NOT_FOUND_ERROR",
  DATABASE_ERROR: "DATABASE_ERROR",
} as const;

export type ErrorCode = (typeof ERROR_CODES)[keyof typeof ERROR_CODES];
